import { AppData, emptyData } from "@/lib/types";

const KEY = "alinea:data:v1";

export const loadData = (): AppData => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...emptyData };
    const parsed = JSON.parse(raw) as Partial<AppData>;
    return { ...emptyData, ...parsed };
  } catch (err) {
    console.error("Alinéa: impossible de lire les données locales, réinitialisation.", err);
    return { ...emptyData };
  }
};

export const saveData = (data: AppData): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (err) {
    console.error("Alinéa: impossible d'enregistrer les données locales.", err);
  }
};

export const uid = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
};
